import React from "react";

import DadosGeraisPropostaSection from "../sections/DadosGeraisPropostaSection";
import HistoricoVendasSection from "../sections/HistoricoVendasSection";
import HistoricoPagamentosSection from "../sections/HistoricoPagamentosSection";
import HistoricoPropostasContratosSection from "../sections/HistoricoPropostasContratosSection";
import TempoRelacionamentoSection from "../sections/TempoRelacionamentoSection";
import AtrasosFinanceiraSection from "../sections/AtrasosFinanceiraSection";
import WorkflowClienteSection from "../sections/WorkflowClienteSection";
import TituloGrupoComponent from "./tituloGrupo/index";

import {
  ComponentWrapper,
  CardWrapper,
  Label,
  CardFilled,
  Card,
} from "./styled";

const RelacionamentoComponent = (props) => {
  const {
    proposalCompleteRegistration = {},
    proposalCompleteRegistrationLoading,
    proposalOperation = {},
    proposalOperationLoading,
    vendaDireta = [],
    vendaDiretaLoading,
    vendaDiretaTotal = {},
    pageVendaDireta = [],
    setFiltersVendaDireta = [],
    filtersVendaDireta = [],
    notaFiscal = [],
    notaFiscalLoading,
    notaFiscalTotal = [],
    pageNotaFiscal = [],
    setFiltersNotaFiscal = [],
    filtersNotaFiscal = [],
    clienteAtrasoFinanceira = [],
    clienteAtrasoFinanceiraLoading,
    resumoPropostas = [],
    resumoPropostasLoading,
    cpfCnpj,
    proposalNumber,
  } = props;

  let dataEmissaoOld = null;

  if (notaFiscal?.length > 0) {
    dataEmissaoOld = notaFiscal
      .map((a) => a.dataEmissao)
      .reduce((a, b) => (a < b ? a : b));
  }

  return (
    <ComponentWrapper>
      <CardWrapper>
        <Label>Dados gerais da proposta</Label>
        <CardFilled>
          <DadosGeraisPropostaSection
            proposalCompleteRegistrationLoading={
              proposalCompleteRegistrationLoading
            }
            proposalOperationLoading={proposalOperationLoading}
            numeroCpfCnpj={proposalCompleteRegistration.cpfCnpj}
            nomeCliente={proposalCompleteRegistration.nomeCliente}
            nomeConvenio={proposalCompleteRegistration.nomeConvenio}
            nomeFilial={proposalCompleteRegistration.nomeFilial}
            nomeFilialFantasia={proposalCompleteRegistration.nomeFilialFantasia}
            numeroProposta={proposalOperation.numeroProposta}
            produto={proposalOperation.produto}
            nomeAnalista={proposalCompleteRegistration.nomeAnalista}
            descricaoStatus={proposalCompleteRegistration.descricaoStatus}
            rankingRelacionamento={
              proposalCompleteRegistration.rankingRelacionamento
            }
            sistemaOrigem={proposalCompleteRegistration.sistemaOrigem}
            pcLtvRisco={proposalCompleteRegistration.pcLtvRisco}
            pcCompRendaCliente={proposalCompleteRegistration.pcCompRendaCliente}
            idRiscoScrCliente={proposalCompleteRegistration.idRiscoScrCliente}
            idRiscoSerasaCliente={
              proposalCompleteRegistration.idRiscoSerasaCliente
            }
          />
        </CardFilled>
      </CardWrapper>

      <CardWrapper>
        <Label>Histórico de vendas</Label>
        <Card>
          <HistoricoVendasSection
            vendaDireta={vendaDireta}
            vendaDiretaLoading={vendaDiretaLoading}
            vendaDiretaTotal={vendaDiretaTotal}
            pageVendaDireta={pageVendaDireta}
            setFiltersVendaDireta={setFiltersVendaDireta}
            filtersVendaDireta={filtersVendaDireta}
            notaFiscal={notaFiscal}
            notaFiscalLoading={notaFiscalLoading}
            notaFiscalTotal={notaFiscalTotal}
            pageNotaFiscal={pageNotaFiscal}
            filtersNotaFiscal={filtersNotaFiscal}
            setFiltersNotaFiscal={setFiltersNotaFiscal}
          />
        </Card>
      </CardWrapper>

      <CardWrapper>
        <Label>Histórico de pagamentos</Label>
        <Card>
          <HistoricoPagamentosSection
            resumoPropostas={resumoPropostas}
            resumoPropostasLoading={resumoPropostasLoading}
            cpfCnpj={cpfCnpj}
            proposalNumber={proposalNumber}
          />
        </Card>
      </CardWrapper>

      <CardWrapper>
        <Label>Histórico de propostas/contratos</Label>
        <Card>
          <HistoricoPropostasContratosSection />
        </Card>
      </CardWrapper>

      <CardWrapper>
        <Label>Tempo de relacionamento</Label>
        <Card>
          <TempoRelacionamentoSection dataEmissaoOld={dataEmissaoOld} />
        </Card>
      </CardWrapper>

      <CardWrapper>
        <TituloGrupoComponent cpfCnpj={cpfCnpj} />
      </CardWrapper>

      <CardWrapper>
        <Label>Atrasos financeira</Label>
        <Card>
          <AtrasosFinanceiraSection
            clienteAtrasoFinanceira={clienteAtrasoFinanceira}
            clienteAtrasoFinanceiraLoading={clienteAtrasoFinanceiraLoading}
          />
        </Card>
      </CardWrapper>

      <CardWrapper>
        <Label>Workflow cliente</Label>
        <Card>
          <WorkflowClienteSection cpfCnpj={cpfCnpj} />
        </Card>
      </CardWrapper>
    </ComponentWrapper>
  );
};

export default RelacionamentoComponent;
